var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-sub-page"},[(_vm.payloadValidated)?_c('div',{staticClass:"content-block"},[_c('content-block-controls'),_c('div',{staticClass:"content-block-body"},[_c('payment-form')],1),_c('content-block-footer')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }